import { instance } from '../../util/http'
import apis from '../../config/apis'
// 查询银行卡状态 是否绑定、通过、未通过 
const getStatus = () => {
    return instance.get(apis.bank.GetStatus)
}
// 获取银行卡驳回原因
const getReject = () => {
    return instance.get(apis.bank.GetReject)
}
// 更改驳回信息状态--点确定
const updateReject = () => {
    return instance.get(apis.bank.UpdateReject)
}

// 解绑银行卡
const put = () => {
    return instance.put(apis.bank.Put)
}
// 获取用户银行卡信息
const get = () => {
    return instance.get(apis.bank.Get)
}

// 获取银行卡卡号
const GetCard = (id) => {
    return instance.get(apis.bank.GetCard + "/" + id )
}

// 添加用户银行卡信息
const addbankCard = (data) => {
    return instance.post(apis.bank.Post,data)
 }

// 银行卡隐私协议
const getMini = (id) => {
    return instance.get(apis.Mini.Get + "?code=" + id )
}



export default {
    getStatus,
    getReject,
    updateReject,
    put,
    get,
    GetCard,
    addbankCard,
    getMini
}